import Icon from "./Icon.jsx";

const NAV = [
  { id: "dashboard", icon: "chart-bar", label: "Dashboard" },
  { id: "command", icon: "grid", label: "Command Center" },
  { id: "pipeline", icon: "pipe", label: "Pipeline" },
  { id: "prospects", icon: "users", label: "Prospects" },
  { id: "signals", icon: "bar", label: "Signals" },
  { id: "campaigns", icon: "mail", label: "Campaigns" },
  { id: "sponsor", icon: "bolt", label: "Sponsor" },
  { id: "memory", icon: "brain", label: "Memory" },
  { id: "settings", icon: "gear", label: "Settings" },
];

export default function Sidebar({ view, onChange, plan, prospectCount, signalCount, onSignOut }) {
  return (
    <div
      style={{
        width: 210,
        background: "var(--s1)",
        borderRight: "1px solid var(--brd)",
        display: "flex",
        flexDirection: "column",
        flexShrink: 0,
      }}
    >
      <div style={{ padding: "20px 16px", display: "flex", alignItems: "center", gap: 7 }}>
        <Icon name="bolt" size={16} color="var(--volt)" fill />
        <span
          style={{
            fontFamily: "var(--d)",
            fontSize: 13,
            fontWeight: 700,
            letterSpacing: "0.15em",
          }}
        >
          VOLTA
        </span>
      </div>

      <nav style={{ flex: 1, padding: "0 6px" }}>
        {NAV.map((n) => {
          const active = view === n.id;
          return (
            <button
              key={n.id}
              onClick={() => onChange(n.id)}
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: 9,
                padding: "9px 10px",
                borderRadius: 8,
                border: "none",
                background: active ? "var(--vg)" : "transparent",
                color: active ? "var(--volt)" : "var(--t2)",
                fontSize: 13,
                fontWeight: active ? 600 : 400,
                fontFamily: "inherit",
                cursor: "pointer",
                marginBottom: 1,
                textAlign: "left",
              }}
            >
              <Icon name={n.icon} size={16} color={active ? "var(--volt)" : "var(--t3)"} />
              {n.label}
            </button>
          );
        })}
      </nav>

      <div style={{ padding: "0 10px 10px" }}>
        <div
          style={{
            padding: "14px 12px",
            borderRadius: 10,
            background: "var(--vg2)",
            border: "1px solid rgba(245,197,24,0.08)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
            <Icon name="bolt" size={14} color="var(--volt)" fill />
            <span
              style={{
                fontFamily: "var(--d)",
                fontSize: 12,
                fontWeight: 700,
                color: "var(--volt)",
              }}
            >
              Fulminio AI
            </span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              fontSize: 11,
              color: "var(--green)",
              marginBottom: 4,
            }}
          >
            <div style={{ width: 5, height: 5, borderRadius: "50%", background: "var(--green)" }} />
            Active
          </div>
          <div style={{ fontSize: 10, color: "var(--t3)" }}>
            {prospectCount} prospects · {signalCount} signals
          </div>
        </div>
      </div>

      <button
        onClick={onSignOut}
        style={{
          margin: "0 10px 12px",
          padding: 7,
          borderRadius: 6,
          border: "1px solid var(--brd)",
          background: "transparent",
          color: "var(--t3)",
          fontSize: 11,
          cursor: "pointer",
        }}
      >
        Sign out
      </button>
    </div>
  );
}

